import Swiper from "swiper";
import "swiper/css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin(ScrollTrigger, CustomEase);
CustomEase.create("sweet", "M0,0 C0.65,0 0.35,1 1,1");

const IMG_DUR = 0.9; // durata reveal immagine (= passo tra una card e la successiva)
const FADE_DUR = 0.7; // durata fade di numero e pill

// Slider delle destinazioni: loop infinito, responsive, trascinabile. In entrata,
// ogni card si rivela in sequenza (immagine top->bottom -> numero -> pill); la card
// successiva parte quando l'immagine della precedente ha finito.
const previewDestinazioni = () => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll(".preview-destinazioni").forEach((section) => {
    const el = section.querySelector(".preview-destinazioni__swiper");
    if (!el) return;

    new Swiper(el, {
      slidesPerView: 1.15,
      spaceBetween: 0,
      loop: true,
      grabCursor: true,
      breakpoints: {
        768: { slidesPerView: 2.2, spaceBetween: 0 },
        1200: { slidesPerView: 2.5, spaceBetween: 0 },
      },
    });

    if (reduce) return;

    const setupEntrance = () => {
      const slides = Array.from(el.querySelectorAll(".preview-destinazioni__slide"));

      // Tutte le slide a stato finale (override del nascosto CSS): evita card
      // bloccate nascoste quando il loop porta in vista un clone.
      slides.forEach((s) => {
        const bg = s.querySelector(".preview-destinazioni__bg");
        if (bg) gsap.set(bg, { clipPath: "inset(0% 0% 0% 0%)" });
        gsap.set(s.querySelectorAll(".preview-destinazioni__num, .preview-destinazioni__foot"), {
          autoAlpha: 1,
        });
      });

      // L'entrata anima solo le slide reali (non i cloni), in ordine.
      const reals = slides.filter((s) => !s.classList.contains("swiper-slide-duplicate"));
      const tl = gsap.timeline({ paused: true, defaults: { ease: "sweet" } });

      reals.forEach((slide, i) => {
        const bg = slide.querySelector(".preview-destinazioni__bg");
        const num = slide.querySelector(".preview-destinazioni__num");
        const foot = slide.querySelector(".preview-destinazioni__foot");
        const at = i * IMG_DUR; // la card i parte quando l'immagine della i-1 finisce

        if (bg)
          tl.fromTo(
            bg,
            { clipPath: "inset(0% 0% 100% 0%)" },
            { clipPath: "inset(0% 0% 0% 0%)", duration: IMG_DUR },
            at
          );
        if (num)
          tl.fromTo(num, { autoAlpha: 0, y: 10 }, { autoAlpha: 1, y: 0, duration: FADE_DUR }, at + IMG_DUR);
        if (foot)
          tl.fromTo(
            foot,
            { autoAlpha: 0, y: 10 },
            { autoAlpha: 1, y: 0, duration: FADE_DUR },
            at + IMG_DUR + 0.25
          );
      });

      ScrollTrigger.create({
        trigger: section,
        start: "top 80%",
        once: true,
        onEnter: () => tl.play(),
      });
      ScrollTrigger.refresh();
    };

    // Come i reveal: se l'intro dell'hero e' in corso, aspetta che finisca (pin in
    // posizione) prima di creare il trigger; altrimenti subito.
    if (document.documentElement.classList.contains("hero-split-intro")) {
      document.addEventListener("hero-split:intro-done", setupEntrance, { once: true });
    } else {
      setupEntrance();
    }
  });
};

export default previewDestinazioni;
